import {Routes} from '@angular/router';
import {multiUserGuard} from '@auth/guards';

export const compliantsRoutes: Routes = [
  { path: 'compliants', loadComponent: () => import('@compliants/pages/home/home').then(m => m.Home), canActivate: [multiUserGuard]},
  { path: 'compliants/:id/phases', loadComponent: () => import('@compliants/pages/compliants-phases/compliants-phases').then(m => m.CompliantsPhases), canActivate: [multiUserGuard]},
];
